export default {
    methods: {

        preloadNextSong(question) {

            if (!question.spotify_track) {
                return
            }

            var bufferToBase64 = function (buffer) {
                var bytes = new Uint8Array(buffer);
                var len = buffer.byteLength;
                var binary = "";
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return window.btoa(binary);
            };

            let cachePreviewUrl = question.spotify_track.cache_preview_url ? question.spotify_track.cache_preview_url : question.spotify_track.preview_url
            cachePreviewUrl = cachePreviewUrl.indexOf('.mp3') > -1 ? cachePreviewUrl : `${cachePreviewUrl}.mp3`

            Object.keys(window.localStorage).forEach((key) => {
                if (key.indexOf('.mp') > -1) {
                    window.localStorage.removeItem(key)
                }
            })

            let req = new XMLHttpRequest()

            req.open('GET', cachePreviewUrl, true)
            req.responseType = 'arraybuffer'

            req.onload = function () {
                if (this.status === 200) {
                    let res = this.response

                    let base64String = bufferToBase64(res)
                    let storageKey = cachePreviewUrl.split('/').pop()
                    window.localStorage.setItem(storageKey, base64String)
                }
            }

            req.send()
        }
    }
}
